import React, { FC, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadReportForm, { IDownloadFormObj } from './DownloadReportForm/DownloadReportForm';
import { DownloadButton, DownloadButtonCont, IconCont } from './DownloadReportModal.styles';
import DownloadReportProgress from './DownloadReportProgress/DownloadReportProgress';
import Modal from '../../HOC/Modal/Modal';
import { useDownloadModal } from '../../hooks/useDownloadModal';
import DownloadIcon from '@/assets/icons/download.svg?react';

interface IDownloadReportModal {
  customReportId?: string;
  customActionButton?: ReactElement;
  metadata: { survey?: { name?: string }; group?: string };
  top?: string;
  customButtonVisible?: boolean;
  setCustomButtonVisible?: (visible: boolean) => void;
}
const DownloadReportModal: FC<IDownloadReportModal> = ({
  customReportId,
  customActionButton,
  top,
  customButtonVisible,
  setCustomButtonVisible,
  metadata,
}) => {
  const [formLang, setFormLang] = useState('en');
  const actionButton = useMemo(() => {
    return customButtonVisible ? customActionButton : <div />;
  }, [customButtonVisible]);
  const { t } = useTranslation();
  const { active, inProgress, downloadFinished, handleModalState, makeDownloadHappend } =
    useDownloadModal();

  const manageModalState = (status: boolean) => {
    if (setCustomButtonVisible) {
      setCustomButtonVisible(status);
    }
    handleModalState(status);
  };

  const submitDownload = () => {
    const applyButton = document.getElementById('downloadReportC2A');
    applyButton?.click();

    if (setCustomButtonVisible) {
      setCustomButtonVisible(false);
    }
  };

  const doDownload = async (data: IDownloadFormObj) => {
    setFormLang(data.preferredLanguage);
    return await makeDownloadHappend(data, customReportId);
  };

  return (
    <>
      <div onClick={() => manageModalState(true)}>
        {customActionButton ? (
          actionButton
        ) : (
          <DownloadButtonCont id="DownloadButtonCont">
            <DownloadButton id="DownloadButton" type="button" $variant="secondary">
              <IconCont id="IconCont">
                <DownloadIcon />
              </IconCont>
              {t('viewSurvey.reportsSetup.downloadModal.download')}
            </DownloadButton>
          </DownloadButtonCont>
        )}
      </div>
      <Modal
        active={active}
        callToAction={submitDownload}
        closeModal={() => manageModalState(false)}
        buttonNames={{
          action: t('viewSurvey.reportsSetup.downloadModal.download'),
          cancel: t('viewSurvey.reportsSetup.downloadModal.cancel'),
        }}
        width="416px"
        top={top || '100px'}
        title={
          inProgress
            ? t('viewSurvey.reportsSetup.downloadModal.downloading')
            : t('viewSurvey.reportsSetup.downloadModal.preferences')
        }
        noC2AButton={inProgress}
      >
        {inProgress ? (
          <DownloadReportProgress
            lang={formLang}
            metadata={metadata}
            downloadFinished={downloadFinished}
            inProgress={inProgress}
          />
        ) : (
          <DownloadReportForm submit={doDownload} />
        )}
      </Modal>
    </>
  );
};

export default DownloadReportModal;
